import { axios } from 'lib/axios';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'lib/auth';


const getByIDRequest = async (id) => {
  try {
    return await axios.get(`/api/blogs/${id}`);
  } catch (error) {
    if (error?.response?.data.description === "record not found") {
      throw new Error("Object doesn't exist");
    }
    
    throw new Error("You don't have permissions to see this object");
  }
};

export const useBlogByID = (id, config = {}) => {
  const { user } = useAuth();
  const configOptions = {select: ({ data }) => data, retry: false, ...config}
  return useQuery({
    queryKey: [`blog-${id}`],
    queryFn: () => getByIDRequest(id),
    ...configOptions
  });
};
